export enum OrderChannel {
  Online = 'online',
  Email = 'email',
  Phone = 'phone',
  Webshop = 'webshop',
  Events = 'events',
  Mpm = 'mpm'
}
